import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import './Navbar.css';
import {Button4} from './Button4';

function Navbar() {
    const [click,setClick] = useState(false);
    const [button,setButton] = useState(true);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const showButton = () => {
        if (window.innerWidth <=960){
            setButton(false)
        }
        else{
            setButton(true)
        }
    };

useEffect(()=>{
    showButton();
}, []);

window.addEventListener('resize', showButton);

  return (
    <>
        <nav className='navbar'>
            <div className="navbar-container">
                <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
                    TRVL <i className="fab fa-typo3" />
                </Link>
                <div className="menu-icon" onClick={handleClick}>
                    <i className={click ? 'fas fa-times' : 'fas fa-bars'}/>
                </div>

                <ul className={click? 'nav-menu active':"nav-menu"}>
                <li className="nav-item">
                    <Link to="/" className='nav-links' onClick={closeMobileMenu}>
                        Home
                    </Link>
                </li>
                <li className="nav-item">
                    <Link to="/packages" className='nav-links' onClick={closeMobileMenu}>
                        Packages
                    </Link>
                </li>
                <li className="nav-item">
                    <Link to="/collaborate" className='nav-links' onClick={closeMobileMenu}>
                        Collaborate
                    </Link>
                </li>
                <li className="nav-item">
                    <Link to="/contact" className='nav-links-mobile' onClick={closeMobileMenu}>
                        Contact Us
                    </Link>
                </li>
                </ul>
                {button && <Button4 buttonStyle='btn--outline'>Connect Now</Button4>}
            </div> 

        </nav>
    </>
  );
}

export default Navbar;